/* eslint-disable react/no-array-index-key */
import _ from 'lodash';
import { useEffectAsync } from 'controls/hooks';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMemberships } from 'actions/memberships';
import { Paragraph } from 'components/atoms/Paragraph/Paragraph';
import { Header } from 'components/atoms/Header/Header';
import { LANGUAGE_SETTINGS } from 'en';
import { ToggleSwitch } from 'components/atoms/ToggleSwitch/ToggleSwitch';
import { MembershipItem } from '../MemberShipItem/MemberShipItem';
import 'components/pages/Memberships/_MemberShips.scss';
import { MembershipsListSkeleton } from './MembershipsListSkeleton';

const MEMBERSHIP_TYPES = {
  monthly: 1,
  annual: 12,
};

const toggleOptions = {
  monthly: 'MONTHLY',
  annual: 'ANNUAL - SAVE Up to 17%',
};

export const MembershipsList = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const userInfo = useSelector((state) => state.userInfo);
  const [memberships, setMemberships] = useState({});
  const [monthly, setShowMonthly] = useState(false);
  const [trialStatus, setTrialStatus] = useState({ freeTrial: true, hasActiveSubscription: false });
  const [needsRefresh, setNeedsRefresh] = useState(false);

  useEffectAsync(async () => {
    if (userInfo) {
      setLoading(true);
      const res = await dispatch(getMemberships());
      let offers = null;
      let trial = null;
      if (!_.isEmpty(res)) {
        [offers, trial] = res;
      }
      setMemberships(!_.isEmpty(offers) ? offers : null);
      setTrialStatus(trial);
      setLoading(false);
    }
  }, [userInfo, needsRefresh]);

  const changeSelector = () => {
    setShowMonthly(!monthly);
  };

  const updateParent = () => {
    setNeedsRefresh(!needsRefresh);
  };

  return (
    <div className='memberships'>
      <Header text={LANGUAGE_SETTINGS.rolandTitle} position='center' />
      { loading ? <MembershipsListSkeleton />
        : (
          <>
            {memberships && <ToggleSwitch optionA={toggleOptions.monthly} optionB={toggleOptions.annual} initialValue={toggleOptions.annual} onChange={changeSelector} />}
            <div className='memberships__list'>
              { memberships && monthly && memberships[MEMBERSHIP_TYPES.monthly].map((e, id) => <MembershipItem key={id} item={e} trialStatus={trialStatus} updateParent={updateParent} />) }
              { memberships && !monthly && memberships[MEMBERSHIP_TYPES.annual].map((e, id) => <MembershipItem key={id} item={e} trialStatus={trialStatus} updateParent={updateParent} />) }
            </div>
          </>
        )}
      <Paragraph text=' Free 30-day Ultimate Trial available exclusively for new users' />
      <Paragraph text={(
        <>
          *Lifetime Keys are available for purchase under the Software and Hardware sections in
          <a href={`${process.env.REACT_APP_HOME}/catalog/essentials/roland-cloud-manager`}> Roland Cloud Manager</a>
          .
        </>
      )}
      />
    </div>
  );
};
